// API base URL — uses relative path in development, Worker URL in production
export const API_BASE = process.env.REACT_APP_API_URL || '';

// Feature flags for UI that isn't wired to a backend yet. Flip on when the
// supporting endpoints exist. (Sprint 4 / D3: hide dead controls rather than
// ship inputs that do nothing.)
export const FEATURES = {
  navbarSearch: false,
  navbarNotifications: false,
} as const;
